import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from "react-i18next";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import React, {useState} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {getCityName} from './Trans.js';
import LocDialog from './LocDialog.js';
import ObsAppBar from './AppBar.js';
import {COMM_OK} from './WsR2.js';

export const LOCT_UNDEF	= 0;
export const LOCT_CITY	= 1;
export const LOCT_ASSO	= 2;
export const LOCT_REG	= 3;
export const LOCT_ADDR	= 4;

export const locTypes = [
	{id: LOCT_UNDEF, desc: '-', 			plural: '-'},
	{id: LOCT_ASSO,  desc: 'locations.club', 	plural: 'stats.clubs'},
	{id: LOCT_CITY,  desc: 'stats.city', 		plural: 'stats.cities'},
	{id: LOCT_REG,   desc: 'add.reg_tgt',		plural: 'stats.reg_tgts'},
	{id: LOCT_ADDR,  desc: 'locations.address',	plural: 'stats.addresses'}
];

export function locListSort(p1, p2) {
	if (p1.loct_id === p2.loct_id)
		return p1.name.localeCompare(p2.name, 'fi');

	if (p1.id === 0)
		return -1;
	if (p2.id === 0)
		return 1;
	if (p1.loct_id === LOCT_ASSO)
		return -1;
	if (p2.loct_id === LOCT_ASSO)
		return 1;
	if (p1.loct_id === LOCT_CITY)
		return 1;
	if (p2.loct_id === LOCT_CITY)
		return -1;

	return p2.loct_id - p1.loct_id;
};

const Locations = observer((props) => {
	const [locDlgOpen, setLocDlgOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const getheader = () => t('menu.locations');

	function editLoc(loc) {
		gStorage.location.setLocation(loc, false);
		setLocDlgOpen(true);
	}

	function toLocDialog() {
		gStorage.location.newLocation();
		setLocDlgOpen(true);
	}

	function locListRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('locListRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'location') {
			if (msg.op === 'statlist') {
				if (msg.result === 'OK') {
					let loclist = {
						last_upd: 0,
						list: msg.data.locationstatlist,
					}

					gStorage.lists.setLocList(loclist);
// 					console.log('locListRxWs: loc list loading OK!', msg);
				} else {
					console.error('locListRxWs:', msg.cmd, msg.op, 'failed!');
				}
			} else {
				console.error('locListRxWs: unknown operation', msg.cmd, msg.op, msg.result);
			}
		} else {
			console.error('locListRxWs: invalid command', msg.cmd, msg.op);
		}
	}

	function locDlgClose(changed) {
		if (changed) {
			let msg = {
				sess_id: gStorage.conn.sess_id,
				cmd: 'location',
				op: 'statlist'
			};

			gStorage.conn.ws.send(msg, locListRxWs);
		}

		setLocDlgOpen(false);
	}

	function locGetCityName(city) {
		return getCityName(city, gStorage.conn.user);
	}

	const locList = gStorage.lists.loclist.list.slice().sort(locListSort);

	return (
		<div>
			<ObsAppBar getheader={getheader} add_action={toLocDialog}/>
			<TableContainer component={Paper} elevation={0}>
				<Table size='small' style={{minWidth:500}}>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>#</TableCell>
							<TableCell >{t('common.name')}</TableCell>
							<TableCell >{t('locations.type')}</TableCell>
							<TableCell >{t('locations.target')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{locList.map((loc, ind) => {
							let tgt_str = '';

							if (loc.loct_id === LOCT_ASSO) {
								const a = gStorage.lists.assolist.list.find(a => a.id === loc.tgt_id);
								if (a) {
									tgt_str = a.name;
								} else {
									tgt_str = '-';
								}
							} else if (loc.loct_id === LOCT_CITY) {
								loc.cities.forEach((cid) => {
									const c = gStorage.lists.citylist.list.find(c => c.id === cid);
									if (c) {
										if (tgt_str.length)
											tgt_str += ', ';
										tgt_str += locGetCityName(c);
									}
								})
							} else if (loc.loct_id === LOCT_REG) {
								const r = gStorage.lists.reglist.list.find(r => r.id === loc.tgt_id);
								if (r) {
									tgt_str = r.name;
								} else {
									tgt_str = '-';
								}
							} else if (loc.loct_id === LOCT_ADDR) {
								const c = gStorage.lists.citylist.list.find(c => c.id === loc.tgt_id);
								if (c)
									tgt_str = locGetCityName(c);

								if (tgt_str.length)
									tgt_str += ', ';
								tgt_str += loc.address;
							}

							return (
								<TableRow style={{cursor: 'pointer'}} key={loc.id}>
									<TableCell onClick={() => editLoc(loc)} padding='checkbox'>{ind + 1}</TableCell>
									<TableCell onClick={() => editLoc(loc)} padding='checkbox'>{loc.name}</TableCell>
									<TableCell onClick={() => editLoc(loc)}>{t(locTypes.find((tgtt) => tgtt.id === loc.loct_id).desc)}</TableCell>
									<TableCell onClick={() => editLoc(loc)}>{tgt_str}</TableCell>
								</TableRow>);
							})
						}
					</TableBody>
				</Table>
			</TableContainer>

			<LocDialog isOpen={locDlgOpen} handleClose={locDlgClose} />
		</div>
	);
});

export default Locations;
